import React, { Component } from 'react';
import { connect } from 'formik';
import { IActivitySettingsPanel, IFormikProps } from '../../models/components/activity-settings';
import { SelectAsync } from '../input/select/main';
import { Confirm } from '../../components/notification/main';
import { Log } from 'ng2-logger';
import Translator from '../../core/i18n';
import Switch from 'react-switch';
import { Common } from '../../core/common';
import { ActivityType } from '../../models/enums/ActivityType';
import Input from '../../components/input/text/input-formik';

const T = Translator.create();
const _logger = Log.create('contact-tabpanael');
let _common: Common;

export class ActivitySettings extends Component<IFormikProps<any>, any> {
    _deletedFilesId = this.props.formik.values.deletedFilesId;
    constructor(props: any) {
        super(props);

        this.state = {
            isSendNotificationOpen: false,
            isUpcomingNotificationOpen: true
        };
        _common = new Common();
    }


    updateUpcomingNotification = (e: any) => {
        this.setState({ isUpcomingNotificationOpen: e });
        this.props.formik.setFieldValue('isUpcomingNotification', e)
    }

    viewYesNoLabel = (status: boolean) => {
        if (status)
            return T.t('r_yes')
        else
            return T.t('r_no')
    }

    public render() {
        return (
            <div
                className={'tab-pane fade' + (this.props.currentTab === '_activitySettingTab' ? ' show active' : '')}
                role="tabpanel"
                aria-labelledby="activity-setting-tab"
            >
                <h5 className="input-label mx-0">{T.t('r_always_on_top')}</h5>
                <div className="col-sm-2 tick-radio text-md-right mt-3" style={{ paddingLeft: 0 }}>
                    <Switch
                        id={'check-onTop'}
                        name={'alwaysOnTop'}
                        onChange={(e: any) => this.props.formik.setFieldValue('alwaysOnTop', e)}
                        checked={this.props.formik.values.alwaysOnTop}
                        onColor="#358730"
                        onHandleColor="#358730"
                        handleDiameter={30}
                        uncheckedIcon={false}
                        checkedIcon={false}
                        boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                        activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                        height={20}
                        width={48}
                        className="react-switch"
                    />
                    <label className='word-break-unset mx-2 my-0' htmlFor="check-onTop">{this.viewYesNoLabel(this.props.formik.values.alwaysOnTop)}</label>
                </div>


                {(this.props.assignedStudentDatas.users && this.props.assignedStudentDatas.users.length > 0 ||
                    this.props.removedStudentDatas.users && this.props.removedStudentDatas.users.length > 0) && (
                        <div>
                            <h5 className="input-label mx-0">{T.t('r_create_special_students')}</h5>
                            <div className="col-sm-2 tick-radio text-md-right mt-3" style={{ paddingLeft: 0 }}>
                                <Switch
                                    id={'isPersonalActivity'}
                                    name={'isPersonalActivity'}
                                    onChange={(e: any) => this.props.formik.setFieldValue('isPersonalActivity', e)}
                                    checked={this.props.formik.values.isPersonalActivity}
                                    onColor="#358730"
                                    onHandleColor="#358730"
                                    handleDiameter={30}
                                    uncheckedIcon={false}
                                    checkedIcon={false}
                                    boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                                    activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                                    height={20}
                                    width={48}
                                    className="react-switch"
                                />
                                <label className='word-break-unset mx-2 my-0' htmlFor="isPersonalActivity">{this.viewYesNoLabel(this.props.formik.values.isPersonalActivity)}</label>
                            </div>
                        </div>
                    )}

                {(this.props.formik.values.isPersonalActivity &&
                    (this.props.assignedStudentDatas.users && this.props.assignedStudentDatas.users.length > 0 ||
                        this.props.removedStudentDatas.users && this.props.removedStudentDatas.users.length > 0)) && (
                        <div className="tabs-section pl-0 pt-1">
                            <div className="announcement-heading">
                                <div>
                                    <div className="activity-spec d-flex align-items-center">
                                        <div style={{ width: '48px !important', height: '48px !important' }} className="spec-icon exam-time"><img src={_common.GetActivityTypeIcons('assignment')} alt="" /></div>
                                        <div className='session_header'>
                                            <h6>
                                                {this.props.formik.values.name}
                                            </h6>
                                        </div>
                                    </div>
                                </div>
                                <div className="session_edit_btn">
                                    <a
                                        className=""
                                        style={{
                                            color: '#212529',
                                            fontSize: 16
                                        }}
                                        onClick={this.props.triggerModal.bind(this, this.props.assignedStudentDatas, this.props.removedStudentDatas, '_assignedStudents')}
                                    >
                                        <span className="edit_btn">
                                            <i className="material-icons">edit</i>
                                        </span>
                                        {T.t('r_fileUpload_edit')}
                                    </a>
                                </div>
                            </div>
                            <div className="create-announcement assignment-modal" style={{ padding: '0em 1em' }}>
                                <div className="row">
                                    <div className="col-md-6 col-12">
                                        <div className="media session_detail_card"
                                            onClick={this.props.triggerModal.bind(this, this.props.assignedStudentDatas, this.props.removedStudentDatas, '_assignedStudents')}
                                        >
                                            <div className="media-body d-flex justify-content-start align-items-center">
                                                <div style={{ width: '48px !important', height: '48px !important' }} className="session_detail_card_icon question_icon"><img className='img-fluid' src={_common.GetDefaultIcons('fillerpersonlight')} alt="" /></div>
                                                <div className='d-flex flex-column align-items-start'>
                                                    <p style={{ margin: 'auto 0' }}>{T.t('r_gen_exam_session_added_students')}</p>
                                                    <h4>{this.props.assignedStudentDatas ? this.props.assignedStudentDatas.users.length : 0}</h4>
                                                </div>
                                            </div>
                                            <div className="session_detail_add_btn">
                                                <span className="add_btn">
                                                    <i className="material-icons">add</i>
                                                </span>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-md-6 col-12">
                                        <div className="media session_detail_card"
                                            onClick={this.props.triggerModal.bind(this, this.props.assignedStudentDatas, this.props.removedStudentDatas, '_removedStudent')}
                                        >
                                            <div className="media-body d-flex justify-content-start align-items-center">
                                                <div style={{ width: '48px !important', height: '48px !important' }} className="session_detail_card_icon person_icon"><img className='img-fluid' src={_common.GetDefaultIcons('fillerpersonlight')} alt="" /></div>
                                                <div className='d-flex flex-column align-items-start'>
                                                    <p style={{ margin: 'auto 0' }}>{T.t('r_add_dropped_students')}</p>
                                                    <h4>{this.props.removedStudentDatas ? this.props.removedStudentDatas.users.length : 0}</h4>
                                                </div>
                                            </div>
                                            <div className="session_detail_add_btn">
                                                <span className="add_btn">
                                                    <i className="material-icons">add</i>
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                {(this.props.displayAllowDownloadSetting && this.props.activityType !== ActivityType.Document) && (
                    <div>
                        <h5 className="input-label mx-0">{T.t('r_allow_download')}</h5>{' '}
                        <div className="col-sm-2 tick-radio text-md-right mt-3" style={{ paddingLeft: 0 }}>
                            <Switch
                                id={'check-onDownload'}
                                name={'allowDownload'}
                                onChange={(e: any) => this.props.formik.setFieldValue('allowDownload', e)}
                                checked={this.props.formik.values.allowDownload}
                                onColor="#358730"
                                onHandleColor="#358730"
                                handleDiameter={30}
                                uncheckedIcon={false}
                                checkedIcon={false}
                                boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                                activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                                height={20}
                                width={48}
                                className="react-switch"
                            />
                            <label className='word-break-unset mx-2 my-0' htmlFor="check-onDownload">{this.viewYesNoLabel(this.props.formik.values.allowDownload)}</label>
                        </div>
                    </div>
                )}
                {/* {(this.props.activityType === ActivityType.Video) && (
                    <div>
                         <h5 className="input-label mx-0">{T.t('r_disallow_video_forward')}</h5>{' '}
                        <div className="col-sm-2 tick-radio text-md-right mt-3" style={{ paddingLeft: 0 }}>
                            <Switch
                                id={'check-forwarding'}
                                name={'disallowForwarding'}
                                onChange={(e: any) => this.props.formik.setFieldValue('disallowForwarding', e)}
                                checked={this.props.formik.values.disallowForwarding}
                                onColor="#358730"
                                onHandleColor="#358730"
                                handleDiameter={30}
                                uncheckedIcon={false}
                                checkedIcon={false}
                                boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                                activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                                height={20}
                                width={48}
                                className="react-switch"
                            />
                            <label  className='word-break-unset mx-2 my-0' htmlFor="check-forwarding">{this.viewYesNoLabel(this.props.formik.values.disallowForwarding)}</label>
                        </div>
                    </div>
                )} */}
                <h5 className="input-label mx-0">{T.t('r_activity_prerequisite')}</h5>{' '}
                <div className="col-sm-2 tick-radio text-md-right mt-3" style={{ paddingLeft: 0 }}>
                    <Switch
                        id={'idActivityPrerequisite'}
                        name={'isActivityPrerequisite'}
                        onChange={(e: any) => this.props.formik.setFieldValue('isActivityPrerequisite', e)}
                        checked={this.props.formik.values.isActivityPrerequisite}
                        onColor="#358730"
                        onHandleColor="#358730"
                        handleDiameter={30}
                        uncheckedIcon={false}
                        checkedIcon={false}
                        boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                        activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                        height={20}
                        width={48}
                        className="react-switch"
                    />
                    <label className='word-break-unset mx-2 my-0' htmlFor="idActivityPrerequisite">{this.viewYesNoLabel(this.props.formik.values.isActivityPrerequisite)}</label>
                </div>
                <div
                    className={'animated ' + (this.props.formik.values.isActivityPrerequisite ? 'fadeInDown' : 'fadeOutDown')}
                    style={{
                        animationDuration: '0.3s',
                        display: this.props.formik.values.isActivityPrerequisite ? 'block' : 'none',
                        marginTop: '1.5rem'
                    }}
                >
                    <SelectAsync
                        isMulti={false}
                        isClearable={true}
                        isSearchable={true}
                        requestType={'post'}
                        parameter={{
                            CourseId: this.props.coursePageActivityId,
                            classId: this.props.coursePageClassId,
                            Take: 7,
                            Skip: 0,
                            activityId: this.props.isUpdate || null
                        }}
                        placeHolder={T.t('r_select_activity')}
                        url={'api/get/conditionalactivities'}
                        closeMenuOnScroll={false}
                        closeMenuOnSelect={true}
                        column={{ label: 'activityName', value: 'activityId' }}
                        setSelectValue={this.props.isUpdate ? this.props.formik.values.prerequisiteActivityId : ''}
                        name={'prerequisiteActivityId'}
                        value={this.props.formik.values.prerequisiteActivityId}
                        onChange={this.props.formik.handleChange}
                        setFieldOnlyValue={true}
                        setFieldValue={this.props.formik.setFieldValue}
                        errors={this.props.formik.errors.prerequisiteActivityId}
                        touched={this.props.formik.touched.prerequisiteActivityId}
                        isTouched={this.props.formik.setFieldTouched}
                        colourStyles={{
                            menu: () => ({
                                // none of react-select's styles are passed to <Control />
                                zIndex: 999999
                            })
                        }}
                    />
                </div>

                <div>
                    <h5 className="mt-4 mb-2">{T.t('r_learning_outcome')}</h5>
                    <SelectAsync
                        isMulti={false}
                        isClearable={true}
                        isSearchable={true}
                        requestType={'get'}
                        parameter={{
                            CourseId: this.props.coursePageActivityId,
                            classId: this.props.coursePageClassId,
                            Take: 7,
                            Skip: 0
                        }}
                        placeHolder={T.t('r_select_learning_outcome')}
                        url={`api/learningoutcomes/course/${this.props.coursePageActivityId}/activity${this.props.isUpdate && ("/" + this.props.isUpdate)}?skip=0&take=50`}
                        closeMenuOnScroll={false}
                        closeMenuOnSelect={true}
                        column={{ label: 'label', value: 'value' }}
                        setSelectValue={this.props.isUpdate ? this.props.formik.values.learningOutcomeId : ''}
                        name={'learningOutcomeId'}
                        value={this.props.formik.values.learningOutcomeId}
                        onChange={this.props.formik.handleChange}
                        setFieldOnlyValue={true}
                        setFieldValue={this.props.formik.setFieldValue}
                        errors={this.props.formik.errors.learningOutcomeId}
                        touched={this.props.formik.touched.learningOutcomeId}
                        isTouched={this.props.formik.setFieldTouched}
                        colourStyles={{
                            menu: () => ({
                                // none of react-select's styles are passed to <Control />
                                zIndex: 999999
                            })
                        }}
                    />
                </div>
                {this.props.activityType === ActivityType.Assignment &&
                    (
                        <>
                            <h5 className="input-label mx-0">{T.t('r_allow_download_after_deadline')}</h5>{' '}
                            <div className="col-sm-2 tick-radio text-md-right mt-3" style={{ paddingLeft: 0 }}>
                                <Switch
                                    id={'allowDownloadAfterDeadline'}
                                    name={'allowDownloadAfterDeadline'}
                                    onChange={(e: any) => this.props.formik.setFieldValue('allowDownloadAfterDeadline', e)}
                                    checked={this.props.formik.values.allowDownloadAfterDeadline}
                                    onColor="#358730"
                                    onHandleColor="#358730"
                                    handleDiameter={30}
                                    uncheckedIcon={false}
                                    checkedIcon={false}
                                    boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                                    activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                                    height={20}
                                    width={48}
                                    className="react-switch"
                                />
                                <label className='word-break-unset mx-2 my-0' htmlFor="allowDownloadAfterDeadline">{this.viewYesNoLabel(this.props.formik.values.allowDownloadAfterDeadline)}</label>
                            </div>
                        </>
                    )}
            </div>
        );
    }
}

export default connect<IActivitySettingsPanel, any>(ActivitySettings);
